import store from '../src/store'
import router from '../src/router'
import events from './plugins/events'
import HexekoDesignSystem from '@tech_hexeko/design-system'
import VueCookies from 'vue-cookies'
import { api, exporterApi, importerApi, verificationApi } from '@tech_hexeko/hexeko-api-classes'

// Hexeko Base Front

let base = {

    install(Vue, options) {

        // Root data
        Vue.prototype.$events = events;
        Vue.prototype.$api = api;
        Vue.prototype.$exporterApi = exporterApi;
        Vue.prototype.$importerApi = importerApi;
        Vue.prototype.$verificationApi = verificationApi;

        // Set options
        this.options = {
            ...{
                name: "Store",
                environment: 'development',
                auth: {
                    type: "password",
                    verify: true,
                    must_be_enabled: false,
                    reset_password_url: null,
                    store_id: null
                },
                api: {
                    baseURL: 'https://api.hexeko.com/api/v1'
                },
                exporterApi: {
                    baseURL: 'https://exporter.api.hexeko.com/api/v1'
                },
                importerApi: {
                    baseURL: 'https://importer.api.hexeko.com/api'
                },
                verificationApi: {
                    baseURL: 'https://api-gateway.hexeko.com/api/v1'
                },
                routes: [],
                log: {
                    rollbarToken: null,
                    enabled: false
                }
            },
            ...options
        }
        this.initConfig(this.options)

        // Design System
        Vue.use(HexekoDesignSystem, {
            availableLanguages: store.state.lang.availableLanguages,
            displayLanguage: store.state.lang.displayLanguage,
            api: api,
            reset_password_url: this.options.auth.reset_password_url
        })

        // Vue cookies
        Vue.use(VueCookies)

        // Login with session
        this.loginWithSession()

        // Listen to resize
        this.resizeListener()

        // Listen to actions
        this.listenActions()

    },

    updateConfig(newOptions) {
        this.initConfig({
            ...this.options,
            ...newOptions
        })
    },

    initConfig(options) {
        // Name
        store.dispatch('changeName', options.name)

        // Auth
        store.dispatch('auth/setConfig', options.auth)

        // Routes
        router.addRoutes(options.routes)

        // Base URL (api, importerApi, exporterApi)
        this.setBaseURL(options.api.baseURL, options.importerApi.baseURL, options.exporterApi.baseURL, options.verificationApi.baseURL)

        // Default lang
        store.dispatch('lang/setDefaultLanguage')
    },

    setLoginErrors(errors) {
        store.dispatch('auth/setLoginErrors', errors)
    },

    listenActions() {
        store.subscribeAction((action) => {
            events.$emit(action.type, action.payload)
        })
    },

    resizeListener() {
        store.dispatch('checkMobileView')
        window.addEventListener('resize', () => {
            store.dispatch('checkMobileView')
        })
    },

    login(payload) {
        // Set token
        this.setToken(payload.token)

        // Go to intended page
        router.push(payload.redirect ? payload.redirect : '/')
    },

    loginWithSession() {
        store.dispatch('auth/loginWithSession')
    },

    setAvailableLanguages(langs) {
        store.dispatch('lang/setAvailableLanguages', langs)
    },

    setLanguage(lang) {
        store.dispatch('lang/setLanguage', lang)
    },

    addTranslations(messages) {
        store.dispatch('lang/addTranslations', messages)
    },

    setToken(token) {
        store.dispatch('auth/setToken', token)
    },

    setBaseURL(urlApi, urlImporterApi, urlExporterApi, urlVerificationApi) {
        store.dispatch('api/setBaseURL', urlApi, { root: true })
        store.dispatch('importerApi/setBaseURL', urlImporterApi, { root: true })
        store.dispatch('exporterApi/setBaseURL', urlExporterApi, { root: true })
        store.dispatch('verificationApi/setBaseURL', urlVerificationApi, { root: true })
    }

}

// i18n
let i18n = store.getters['lang/i18n']

// Export

export {
    store,
    router,
    base,
    events,
    api,
    i18n
}
